import React from 'react';
import { Stack, Typography, useTheme } from '@mui/material';

import { Container } from '@/components/layout';
import Icon from '@/components/icons/Icon';

const DATA = [
  {
    value: '80%+',
    title: 'Employee Engagement',
    description:
      'People love the simplicity, personalization, and impact of OneVillage.',
  },
  {
    value: '95%',
    title: 'Client Retention',
    description:
      'Our clients value our personalized solutions and service and our data-driven results',
  },
  {
    value: '4.9/5',
    valueIcon: {
      name: 'star',
      size: '28px',
    },
    title: 'User Satisfaction',
    description: 'The average users rates their session 4.9 of 5.0 stars',
  },
];

function MetricItem({
  value,
  title,
  description,

  valueIcon,
}: {
  key: string;
  value: string;
  title: string;
  description: string;

  valueIcon?: {
    name: string;
    size: string;
  };
}) {
  const theme = useTheme();

  return (
    <Stack
      sx={{
        flex: 1,
      }}
    >
      <Stack
        sx={{
          gap: theme.spacing(0.5),
          marginBottom: theme.spacing(5),
          paddingBottom: theme.spacing(5),
          borderBottom: `1px solid ${theme.palette.warning[800]}`,
        }}
      >
        <Stack
          sx={{
            gap: theme.spacing(1.5),
            flexDirection: 'row',
            justifyContent: 'center',
          }}
        >
          <Typography
            fontSize="3.125rem !important"
            lineHeight="1.18 !important"
            variant="h3"
            fontWeight="700"
            color={theme.palette.warning[900]}
            textAlign="center"
          >
            {value}
          </Typography>

          {!!valueIcon && (
            <Icon
              iconName={valueIcon.name}
              style={{
                color: theme.palette.secondary[500],
                width: valueIcon.size,
                height: valueIcon.size,
                marginTop: '20px',
              }}
            />
          )}
        </Stack>

        <Typography
          fontSize="1.1875rem !important"
          lineHeight="1.375 !important"
          fontWeight="700"
          variant="body2"
          color={theme.palette.warning[900]}
          textAlign="center"
        >
          {title}
        </Typography>
      </Stack>

      <Typography
        fontSize="1.125rem !important"
        lineHeight="1.46 !important"
        variant="body2"
        color={theme.palette.secondary[900]}
        textAlign="center"
      >
        {description}
      </Typography>
    </Stack>
  );
}

function Metrics() {
  const theme = useTheme();

  return (
    <Stack
      sx={{
        paddingTop: theme.spacing(11),
        paddingBottom: theme.spacing(13),
        backgroundColor: '#FFF4DA',
      }}
    >
      <Container>
        <Stack
          sx={{
            gap: theme.spacing(12.5),
            flexDirection: { xs: 'column', lg: 'row' },
            flexWrap: 'wrap',
            justifyContent: 'center',
            px: { xs: theme.spacing(5), lg: 'unset' },
          }}
        >
          {DATA.map((item) => (
            <MetricItem key={item.title} {...item} />
          ))}
        </Stack>
      </Container>
    </Stack>
  );
}

export default Metrics;
